import { GeneratedOutline } from '../reducers/generated-outline';

export interface TransformedModule {
  title: string;
  duration: string;
  screens: number;
  lessons: Array<{
    title: string;
    duration: string;
    objectives: string[];
  }>;
}

export interface TransformedOutline {
  title: string;
  description: string;
  modules: TransformedModule[];
}

export const transformGeneratedOutline = (outline: GeneratedOutline): TransformedOutline => {
  if (!outline) {
    console.error('Outline is undefined or null');
    return {
      title: 'Course Outline',
      description: 'No outline available',
      modules: [],
    };
  }

  if (!outline.modules || !Array.isArray(outline.modules)) {
    console.error('Outline modules is undefined, null, or not an array:', outline.modules);
    return {
      title: outline.name || 'Course Outline',
      description: outline.description || 'No description available',
      modules: [],
    };
  }

  return {
    title: outline.name || 'Course Outline',
    description: outline.description || '',
    modules: outline.modules.map((module) => {
      if (!module || !module.screens || !Array.isArray(module.screens)) {
        console.error('Invalid module structure:', module);
        return {
          title: module?.name || 'Unknown Module',
          duration: '0m',
          screens: 0,
          lessons: [],
        };
      }

      return {
        title: module.name || 'Unknown Module',
        duration: `${module.duration || 0}m`,
        screens: module.screens.length,
        lessons: module.screens.map((screen) => ({
          title: screen?.title || 'Unknown Screen',
          duration: `${Math.ceil((module.duration || 0) / Math.max(module.screens.length, 1))}m`,
          objectives: screen?.contentPoints || [],
        })),
      };
    }),
  };
};
